import Http from '../utilities/http';

export class VehicleBrokerSubmissionApi {
  static search(vehicleId) {
    return Http.get('/vehicle-broker-submission/search', {vehicleId}).then((res) => res.data);
  }
}
